﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiffCalcABI = void 0;
class DiffCalcABI {
    static GetABI() {
        return [
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "llVaultManager_",
                        "type": "address"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "inputs": [],
                "name": "llSortedVaults",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "llVaultManager",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "to_",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "maxSteps_",
                        "type": "uint256"
                    }
                ],
                "name": "searchDiff",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "debt_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "last_",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            }
        ];
    }
}
exports.DiffCalcABI = DiffCalcABI;
//# sourceMappingURL=DiffCalcABI.js.map